import { writable } from 'svelte/store';
import { idb } from '../db.js';

const DB_TABLE = `pc_stores`;

const initStores = () => {
    const { subscribe, set, update } = writable();
    const helpers = {
        init: async () => {
            let storesDb = await idb.getAll(DB_TABLE);
            console.log(storesDb);
            
            storesDb.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
            set(storesDb);
        },  
        add: ( data ) => { 
            update( state => {
                if ( ! state ) state = [];
                const newState = state.concat(data);
                state.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
                console.log(`New state`);console.log(newState);
                idb.save( DB_TABLE, newState);
                return newState; 
            })
        },
        find: ( uid ) => { get(lists).find( state => state.uid == uid) },
        edit: ( uid, data ) => { update( state => state[state.findIndex( state => state.uid == uid)] = data ) },
        delete: ( uid ) => { update( state => state.filter( state => state.uid != uid) )}
    }
    return {
        subscribe,
        ...helpers
    }
}

export const stores = initStores();

stores.subscribe(value => {
    localStorage.setItem(DB_TABLE, JSON.stringify(value));
});